module.exports = __webpack_public_path__ + "img/TXT-SOCIAL-YOUCARING.1eb1195e.png";